import { Announcements, UniqueIdentifier } from '@dnd-kit/core'

import { DataTypeRecord, KanbanItemProps, KanbanItemRequiredFields } from './types'

export const announcements: Announcements = {
  onDragStart({ active }) {
    return `Picked up draggable item ${active.id}.`
  },
  onDragOver({ active, over }) {
    if (over) {
      return `Draggable item ${active.id} was moved over droppable area ${over.id}.`
    } else {
      return `Draggable item ${active.id} is no longer over a droppable area.`
    }
  },
  onDragEnd({ active, over }) {
    if (over) {
      return `Draggable item ${active.id} was dropped over droppable area ${over.id}`
    } else {
      return `Draggable item ${active.id} was dropped.`
    }
  },
  onDragCancel({ active }) {
    return `Dragging was cancelled. Draggable item ${active.id} was dropped.`
  }
}

export function getContainer<T extends KanbanItemRequiredFields>(
  items: DataTypeRecord<T>[],
  id: UniqueIdentifier
): DataTypeRecord<T> | undefined {
  return items.find((column) => column.id === id)
}

export function getIndex<T extends KanbanItemRequiredFields>(
  data: T[],
  id: UniqueIdentifier
): number {
  return data.map((item) => item.id).indexOf(id)
}

export function getItem<T>(
  columns: DataTypeRecord<T & KanbanItemRequiredFields>[],
  id: UniqueIdentifier
): KanbanItemProps<T> | undefined {
  for (const column of columns) for (const item of column.data) if (item.id === id) return item
}
